import { render } from "./vue-horizontal.vue?vue&type=template&id=5320e3e8&ts=true"
import script from "./vue-horizontal.vue?vue&type=script&lang=ts"
export * from "./vue-horizontal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__